import * as React from 'react'
import Navbar from '../../setup/Navbar'
import { Container, Grid2 } from '@mui/material'
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import StickyHeadTable from '../../../BuiltInComponent/TableWithPagination'
import Loading from '../../../BuiltInComponent/Loading'
import { getPDMasterData } from '../../../features/StockManagement/Purchases/pdSlice'

export default function PurchaseRequestList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { masterData, isLoading } = useSelector((state) => state.pd)

    React.useEffect(() => {
        dispatch(getPDMasterData())
        // dispatch(getPurchaseDetailData('blank'))
    }, [dispatch])

    const tableColumns = [
        { fieldName: 'pdID', cName: 'Invoice No', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'pdID', cName: 'P.R. ID', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'entDate', cName: 'Post Date', textAlign: 'left', width: 80, status: 'en', dType: 'date' },
        { fieldName: 'dispName', cName: 'Request By', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'PartyName', cName: 'Department', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'remarks', cName: 'Remarks', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'poStatus', cName: 'Current Status', textAlign: 'left', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'totalItems', cName: 'Total Items', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
        { fieldName: 'Edit', cName: 'Edit', textAlign: 'center', width: 80, status: 'en', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
    ];

    const onEditClick = async (itemCode) => {
        navigate('/AddGRN', { state: { pdID: itemCode } })
    }
    const onDeleteClick = async (itemCode) => { }

    const onAddNewClick = () => {

        navigate('/AddGRN')

    }

    return (
        <>
            <Navbar />
            <Container>
                <Grid2 container spacing={2} sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={8}>

                    </Grid2>
                    <Grid2 size={4}>
                        <ButtonNormal text='Add New Purchase Delvery (GRN)' onClick={onAddNewClick} />
                    </Grid2>
                </Grid2>
                {isLoading ? <Loading /> :
                    <StickyHeadTable tableColumns={tableColumns} tableData={masterData && masterData}
                        onEditClick={onEditClick} onDeleteClick={onDeleteClick} />
                }

            </Container>
        </>
    )
}